/**
 * The customer details card with its permission fetched.
 *
 * The hook is exported alongside the view because a page may need the permission without the card,
 * and because which organisation's record to take is a rule worth having in one place rather than
 * repeated at each call site.
 */
export { default as IndividualDetailsView } from './IndividualDetailsView';
export type { TIndividualDetailsViewProps } from './IndividualDetailsView';

export { useCustomerPermission } from './useCustomerPermission';
export type { TUseCustomerPermission, TUseCustomerPermissionParams } from './useCustomerPermission';
